<template>
  <button class="category" @click.stop="click">
    <div class="d-flex flex-column container-icon">
      <i :class="icon"></i>
      <span class="label-category">
        {{ name }}
      </span>
    </div>
  </button>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: () => ""
    }
  },
  computed: {
    icon() {
      switch (this.name.toLowerCase()) {
        case "empreendedorismo digital":
          return "icon-headset";
        case "tecnologia da informação":
          return "icon-code";
        case "apps & software":
          return "icon-desktop";
        case "educação":
          return "icon-student";
        case "saúde e esportes":
          return "icon-emoji-happy";
        case "idiomas":
          return "icon-comment";
        case "desenvolvimento pessoal":
          return "icon-user";

        default:
          return "icon-landing-page";
      }
    }
  },
  methods: {
    click() {
      this.$emit("select", this.name);
    }
  }
};
</script>
<style lang="scss" scoped>
.category {
  border: none;
  border-radius: 4px;
  width: 100%;
  height: 172px;
  background: #eadcff;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
  position: relative;
  color: #393444;

  .container-icon {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);

    i {
      font-size: 50px;
    }

    .label-category {
      padding-top: 12px;
      font-size: 12px;
      font-weight: bold;
    }
  }
}
</style>
